import React from "react";
// import { Helmet } from "react-helmet";
import { Heading, Flex, Box } from "rebass";
import styled, { withTheme } from "styled-components";
import { compose } from "redux";
import componentQueries from "react-component-queries";
import Image from "../../components/image";
import Gallery from "../../components/gallery";
import { ProjectSeo } from "../../templates/meta";
import Overlay from "../../components/overlay";
import Metadata from "../../components/metadata";
import InstaGallery from "../../components/insta-gallery";
import Text from "../../components/text";
import Video from "../../components/video";
import Caption from "../../components/caption";
import ProjectGrid from "../../components/projectgrid";

function cleanBodyItems(list) {
  return list.map(item => {
    const newItem = {};
    Object.keys(item).forEach(key => {
      if (item[key]) {
        newItem[key] = item[key];
      }
    });
    return newItem;
  });
}

const Banner = styled(Image)`
  padding-bottom: ${({ pb, theme }) => theme.space[pb]};
`;

const widthQuery = componentQueries(({ width }, props) => {
  const layoutProps = (function mapWidthToLayoutProps() {
    const dFault = {
      gutter: {
        x: 0,
        y: 12
      },
      caption: {
        w: 0.8,
        f: 11,
        pt: 9
      },
      blurb: {
        w: 1,
        f: 12,
        pl: `${parseFloat(props.theme.space[5].replace("vw", "")) / 2}vw`
      },
      metadata: {
        w: 1,
        f: 11,
        pl: `${parseFloat(props.theme.space[5].replace("vw", "")) / 2}vw`,
        ratio: [1, 2],
        wrap: false,
        border: true,
        mb: 10
      },
      text: {
        w: 1,
        f: 12,
        columns: 1
      },
      image: {
        w: () => 1
      },
      video: {
        w: 1
      },
      gallery: {
        w: 1
      },
      instagrid: {
        columns: 2,
        pt: 15,
        f: 11,
        hf: 12
      }
    };

    if (width > 1000) {
      return {
        ...dFault,
        gutter: {
          y: 8,
          x: 8
        },
        caption: {
          w: 0.6,
          f: 6,
          pt: 5
        },
        blurb: {
          w: 1 / 2,
          f: 8,
          pr: "7%"
        },
        metadata: {
          w: 1 / 2,
          f: 6,
          pl: `${parseFloat(props.theme.space[8].replace("vw", "")) / 2}vw`,
          mb: 10,
          wrap: false,
          border: false,
          ratio: [1.5, 3.5]
        },
        text: {
          w: 0.8,
          f: 7,
          columns: 2
        },
        instagrid: {
          columns: 4,
          f: 6,
          pt: 14,
          hf: 9
        }
      };
    }

    if (width > 700) {
      return {
        ...dFault,
        gutter: {
          ...dFault.gutter,
          y: 10
        },
        blurb: {
          ...dFault.blurb,
          f: 10
        },
        caption: {
          ...dFault.caption,
          w: 0.8,
          f: 8,
          pt: 5
        },
        metadata: {
          ...dFault.metadata,
          f: 8,
          mb: 7
          // wrap: false,
          // ratio: [1, 3.5],
        },
        text: {
          ...dFault.text,
          f: 9
        },
        instagrid: {
          ...dFault.instagrid,
          f: 8,
          columns: 3,
          hf: 10
        }
      };
    }

    if (width > 500) {
      return {
        ...dFault,
        gutter: {
          ...dFault.gutter,
          y: 10
        },
        caption: {
          ...dFault.caption,
          f: 9
        },
        blurb: {
          ...dFault.blurb,
          f: 11
        },
        metadata: {
          ...dFault.metadata,
          f: 9,
          mb: 8
        },
        text: {
          ...dFault.text,
          f: 10
        },
        instagrid: {
          ...dFault.instagrid,
          f: 9,
          columns: 3,
          hf: 10
        }
      };
    }
    return dFault;
  })();

  return {
    layoutProps
  };
});

const Project = props => {
  const { data: { project }, layoutProps } = props;
  const body = cleanBodyItems(project.body);
  const tag1 = project.tags[0];
  const tag2 = project.tags[1];
  const instagramPosts = project.instagramPosts.filter(
    ({ url }) => url !== "dummy"
  );
  const { relatedProjects } = project;
  return (
    <Flex column pt={10}>
      <ProjectSeo {...project} />
      <Overlay
        elements={[
          [
            tag1 ? tag1.value : "RO",
            { style: { color: tag1 ? tag1.color.hex : "black" } }
          ],
          [project.title],
          ["&"],
          [
            tag2 ? tag2.value : "AD",
            { style: { color: tag2 ? tag2.color.hex : "black" } }
          ]
        ]}
      />
      <Banner background ratio={1 / 2} file={project.bannerImage} />
      <Flex py={layoutProps.gutter.y} wrap>
        <Box
          f={layoutProps.blurb.f}
          w={layoutProps.blurb.w}
          pr={layoutProps.blurb.pr}
        >
          <p>{project.blurb}</p>
        </Box>
        <Box
          f={layoutProps.metadata.f}
          w={layoutProps.metadata.w}
          pl={layoutProps.metadata.pl}
        >
          <Metadata
            data={project.metadata}
            layoutProps={layoutProps.metadata}
          />
        </Box>
      </Flex>
      {body.map(item => {
        switch (item.itemType) {
          case "video": {
            return (
              <Flex
                column
                key={item.id}
                align="center"
                w={1}
                pb={layoutProps.gutter.y}
              >
                <Box w={layoutProps.video.w}>
                  <Video name="video" {...item} />
                </Box>
                <Box {...layoutProps.caption}>
                  <Caption>{item.content.title}</Caption>
                </Box>
              </Flex>
            );
          }
          case "image": {
            return (
              <Flex
                key={item.id}
                column
                align="center"
                justify="center"
                pb={layoutProps.gutter.y}
                w={1}
              >
                <Image
                  w={layoutProps.image.w(item)}
                  pb={layoutProps.image.pb}
                  file={item.file}
                />
                {item.caption && (
                  <Box {...layoutProps.caption}>
                    <Caption
                      dangerouslySetInnerHTML={{ __html: item.caption }}
                    />
                  </Box>
                )}
              </Flex>
            );
          }
          case "text": {
            return (
              <Flex key={item.id} justify="center" pb={layoutProps.gutter.y}>
                <Text
                  f={layoutProps.text.f}
                  w={layoutProps.text.w}
                  columns={layoutProps.text.columns}
                  gutter={layoutProps.gutter.x}
                  {...item}
                />
              </Flex>
            );
          }
          case "gallery": {
            return (
              <Flex key={item.id} justify="center" pb={layoutProps.gutter.y}>
                <Box w={layoutProps.gallery.w}>
                  <Gallery {...item} />
                </Box>
              </Flex>
            );
          }
          default: {
            console.warn(`${item.itemType} not in implemented`);
            return null;
          }
        }
      })}
      {instagramPosts.length > 0 && (
        <Box pt={layoutProps.instagrid.pt}>
          <Heading f={layoutProps.instagrid.hf}>
            Ondertussen op Instagram...
          </Heading>
          <InstaGallery
            f={layoutProps.instagrid.f}
            columns={layoutProps.instagrid.columns}
            images={instagramPosts}
          />
        </Box>
      )}
      {relatedProjects.length > 0 && (
        <Box pt={layoutProps.instagrid.pt}>
          <Heading f={layoutProps.instagrid.hf}>Verwante Projecten</Heading>
          <ProjectGrid projects={relatedProjects} />
        </Box>
      )}
    </Flex>
  );
};

export default compose(withTheme, widthQuery)(Project);

export const pageQuery = graphql`
  query ProjectBySlug($slug: String!) {
    globalSeo {
      en {
        siteName
        titleSuffix
        fallbackSeo {
          title
          description
          image {
            path
          }
        }
      }
      favicon {
        path
      }
    }
    project(slug: { eq: $slug }) {
      bannerImage {
        url
      }
      seoMetaTags {
        tagName
        content
        attributes {
          name
          content
        }
      }
      title
      tags {
        value
        color {
          hex
        }
      }
      metadata {
        itemType
        label
        value
        coordinates {
          longitude
          latitude
        }
        displayName
      }
      blurb
      # the body contains mixed types and unfortunately gatsby merges them into a single type instead of creating a union type
      # so we pull all the possible props in and clean them up in cleanBodyItems
      body {
        id
        # all
        itemType
        # text
        html
        # image and image_with_caption
        file {
          url
        }
        # image_with_caption
        caption
        # gallery
        images {
          url
        }
        # video
        content {
          url
          width
          thumbnailUrl
          height
          provider
          title
        }
      }
      instagramPosts {
        url
      }
      relatedProjects {
        id
        slug
        title
        bannerImage {
          url
        }
        metadata {
          itemType
          value
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/project/index.js